module.exports = __webpack_public_path__ + "img/Z61_02.11b815b4.jpg";